import { SvgIcon, SvgIconProps } from './SvgIcon';

export const ChatBubbleFilledIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.25 9C1.25 5.82436 3.82436 3.25 7 3.25H13C16.1756 3.25 18.75 5.82436 18.75 9C18.75 12.1756 16.1756 14.75 13 14.75H9.69103L6.20771 16.6501C4.87496 17.3771 3.24997 16.4125 3.24997 14.8943V13.359C2.02649 12.3054 1.25 10.7433 1.25 9ZM6.5 10C7.05228 10 7.5 9.55228 7.5 9C7.5 8.44772 7.05228 8 6.5 8C5.94772 8 5.5 8.44772 5.5 9C5.5 9.55228 5.94772 10 6.5 10ZM11 9C11 9.55228 10.5523 10 10 10C9.44771 10 9 9.55228 9 9C9 8.44772 9.44771 8 10 8C10.5523 8 11 8.44772 11 9ZM13.5 10C14.0523 10 14.5 9.55228 14.5 9C14.5 8.44772 14.0523 8 13.5 8C12.9477 8 12.5 8.44772 12.5 9C12.5 9.55228 12.9477 10 13.5 10Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
